// LoadingSpinner.tsx
import React from 'react';
import { FadeLoader } from 'react-spinners';

interface LoadingSpinnerProps {
  title?: string; // Optional title prop
  loading: boolean;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ title = "Loading...", loading }) => {
  return (
    <div
      title={title}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(255, 255, 255, 0.3)',
        backdropFilter: 'blur(5px)',
        zIndex: 9999,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        // Prevent pointer events from reaching underlying content
        pointerEvents: 'all'
      }}
    >
      <FadeLoader color="#FF8343" loading={loading} height={30} width={8} radius={4} margin={15} />
    </div>
  );
};

export default LoadingSpinner;
